<img [ngClass]="$layoutClass()" [src]="$url() ?? fallbackUrl" draggable="false" alt="Thumbnail" (load)="load.emit($event)" />
